import { render, staticRenderFns } from "./CategoryTags.vue?vue&type=template&id=e9a67b44&"
import script from "./CategoryTags.vue?vue&type=script&lang=js&"
export * from "./CategoryTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports